import { UserRole } from '@today/types'
import { PlatformBrandSwitcherView } from '@today/ui-domain'
import type { RouteObject } from 'react-router-dom'
import { RequireRole } from '@/components/RequireRole'
import { usePlatformBrandSwitcher } from '@/hooks/usePlatformBrandSwitcher'

/**
 * `/admin/platform/brand` — the Super-Admin platform-brand switcher (TO-541
 * REQ-108). A UI convenience: the `PUT`'s SUPER_ADMIN gate is the authority.
 */
export function PlatformBrandPage() {
	const switcher = usePlatformBrandSwitcher()
	return (
		<div className="flex flex-col gap-6">
			<div>
				<h1 className="text-2xl font-bold text-ds-text">Platform brand</h1>
				<p className="mt-1 text-sm text-ds-text-muted">
					The brand of the sign-in page, the platform backoffice and every surface without a tenant brand.
				</p>
			</div>
			{switcher.loading ? null : (
				<PlatformBrandSwitcherView
					options={switcher.options}
					currentId={switcher.currentId}
					selectedId={switcher.selectedId}
					onSelect={switcher.select}
					onSave={switcher.save}
					saving={switcher.saving}
					error={switcher.error}
					notice={switcher.notice}
				/>
			)}
		</div>
	)
}

/** `/admin/platform/brand` — SUPER_ADMIN only; any other role is redirected to `/dashboard`. */
export const platformBrandRoute: RouteObject = {
	path: 'platform/brand',
	element: (
		<RequireRole anyOf={[UserRole.SUPER_ADMIN]}>
			<PlatformBrandPage />
		</RequireRole>
	),
}
